<template>
  <div class="status-box">
    <BaseTile class="status-tile">
      <template v-slot:headertext>
        <p class="subtitle" v-html="$t('status.box_title')"></p>
      </template>
      <template v-slot:bodytext>
        <StatusMessage />
      </template>
      <template v-slot:footertext>
        <div v-if="$i18n.locale == 'fr'">
          <b-button
            outlined
            type="is-primary"
            :href="sorryLinkFr"
            tag="a"
            target="_blank"
            >{{ $t("status.status_btn") }}</b-button
          >
        </div>
        <div v-else>
          <b-button
            outlined
            type="is-primary"
            :href="sorryLink"
            tag="a"
            target="_blank"
            >{{ $t("status.status_btn") }}</b-button
          >
        </div>
      </template>
    </BaseTile>
  </div>
</template>

<script>
import StatusMessage from "@/components/StatusMessage.vue";
import BaseTile from "@/components/base-components/BaseTile.vue";
export default {
  name: "StatusBox",
  data() {
    return {
      sorryLink: process.env.VUE_APP_SORRY_LINK,
      sorryLinkFr: process.env.VUE_APP_SORRY_LINK_FR
    };
  },
  components: {
    StatusMessage,
    BaseTile
  }
};
</script>

<style lang="scss">
.status-tile .custom-tile {
  background: white;
  display: flex;
  flex-direction: column;
}
.status-tile .tile-footer {
  justify-content: flex-end;
}
</style>
